import { ChangeDetectorRef, Component, DoCheck, ElementRef, EventEmitter, Inject, Input, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { SettingsService } from '../../service/settings.service';
import { ContentTypeService } from '../../service/content-type.service';
import { CommentsService } from '../../service/comments.service';
import { TranslateService } from '@ngx-translate/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { deepCopy, listTypesOptions, typesOptions } from 'na-lib';
import { ContentTypesSchemaPropertiesDialogComponent } from '../content-types-schema-properties-dialog/content-types-schema-properties-dialog.component';
import { ContentType } from 'na-lib';
import { ExcelImportService, SchemaImportError, SchemaNode } from '../../service/excel-import.service';
import { EMPTY_SCHEMA_META_TEMPLATE, getMissingMandatoryMetaFields, SchemaFieldMeta, SchemaMetaTemplate } from '../schema-meta.model';
import { SchemaEditorService } from '../schema-editor.service';
import { JsonSchemaImportService } from '../json-schema-import.service';
import { SchemaMetaTemplateDialogComponent } from '../schema-meta-template-dialog/schema-meta-template-dialog.component';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx/xlsx.mjs';
import { firstValueFrom } from 'rxjs';

type schemaNode = SchemaNode;
type SchemaDropList = { nodes: schemaNode[] };
type AccessRow = { node: schemaNode; path: number[]; label: string; parentLabel: string; depth: number };
type SchemaSearchResult = { node: schemaNode; label: string; parentLabel: string };
type AccessFilter = 'all' | 'custom' | 'inherited' | 'open';

@Component({
    selector: 'app-content-types-schema-view-dialog',
    templateUrl: './content-types-schema-view-dialog.component.html',
    styleUrls: ['./content-types-schema-view-dialog.component.css'],
    standalone: false
})
export class ContentTypesSchemaViewDialogComponent implements DoCheck {
  @Input() embedded = false;
  @Input() embeddedContentType: any;
  @Output() schemaApplied = new EventEmitter<[boolean, any, SchemaMetaTemplate]>();
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild('schemaImportWarning') schemaImportWarning!: TemplateRef<unknown>;
  @ViewChild('schemaImportWarningsDialog') schemaImportWarningsDialog!: TemplateRef<unknown>;
  @ViewChild('schemaTree', { read: ElementRef }) schemaTreeElement?: ElementRef<HTMLElement>;
  routerUrl:any
  idToShow:any
  currentRoute:any
  contentTypeUserRights_update:any
  contentTypeUserRights_delete:any
  schemaData:any
  schemaForm!:FormGroup
  contentForm!:FormGroup
  contenttype:any
  contentData:any
  displayName:any
  propertiesTypes={
   
  }
  typesOptions:any = typesOptions
  listTypesOptions:any = listTypesOptions
  oldSchema:any
  allproperties:schemaNode[]
  TREE_DATA:schemaNode[]
  treeControl = new NestedTreeControl<schemaNode>(node => this.schemaChildren(node));
  dataSource = new MatTreeNestedDataSource<schemaNode>();
  selectedFieldPath: number[] | undefined;
  selectedFieldForm!: FormGroup;
  metaTemplate: SchemaMetaTemplate = deepCopy(EMPTY_SCHEMA_META_TEMPLATE);
  metaExpanded = false;
  schemaImportWarnings: Array<{ path: string; message: string }> = [];
  schemaImportFieldCount = 0;
  accessView = false;
  accessBulkMode = false;
  bulkAccess: Record<string, string[]> = { public: ['R'] };
  accessSearch = '';
  schemaSearch = '';
  accessFilter: AccessFilter = 'all';
  accessSelectedPaths = new Set<string>();
  accessNewRole = '';
  @ViewChild('accessBulkWarning') accessBulkWarning!: TemplateRef<unknown>;
  private embeddedState = '';


  constructor(
    private changeDetector: ChangeDetectorRef,
    public dialog: MatDialog,
    private settingsService: SettingsService,
    private contentTypeService: ContentTypeService,
    private fb: FormBuilder,
    private commentService: CommentsService,
    private excelImportService: ExcelImportService,
    private schemaEditor: SchemaEditorService,
    private jsonSchemaImport: JsonSchemaImportService,
    private translate:TranslateService,
    @Optional() public dialogRef: MatDialogRef<ContentTypesSchemaViewDialogComponent> | null,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any){
  }

  ngOnInit(){
    this.idToShow = this.data?.id || this.embeddedContentType?.id
    this.contentData = this.data?.contentType || this.embeddedContentType
    this.contentForm = this.fb.group({
      schema:[]
    })
    this.schemaForm = this.fb.group({
      properties:[],
      type:[]
    })
    this.selectedFieldForm = this.fb.group({
      type: [undefined, Validators.required],
      key: [undefined, [Validators.required, Validators.pattern('^(?![_\\.])(?!.*[_\\.]$)(?!.*[\'\";,#%&<>(){}\\[\\]/\\\\|`*@$^=+?!]).*$')]],
      description: [undefined],
      mandatory: [false],
      listItemsType: [undefined]
    })
    this.selectedFieldForm.valueChanges.subscribe(() => this.saveSelectedField(false));
    
    if(this.contentData){
      this.contenttype = deepCopy(this.contentData)
      if(this.contenttype.displayName)
        this.displayName = this.contenttype.displayName
      if(this.contenttype.schema){
        this.schemaData = this.contenttype.schema
        this.oldSchema = deepCopy(this.schemaData)
        if(this.schemaData.properties)
          this.allproperties=this.schemaData.properties
        else
          this.allproperties=[]
        this.initializeForm()
      }else{
        this.initializeDefaultForm()

      }
      this.metaTemplate = deepCopy(this.contenttype.metaTemplate || EMPTY_SCHEMA_META_TEMPLATE);

    }else{
      this.getContentTypeId()
    }
    this.contentTypeUserRights_update = this.settingsService.modulesRolesRights$.value['contentTypes']['U']
    this.contentTypeUserRights_delete = this.settingsService.modulesRolesRights$.value['contentTypes']['D']

    this.settingsService.modulesRolesRights$.subscribe( value => {
      this.contentTypeUserRights_update = this.settingsService.modulesRolesRights$.value['contentTypes']['U']
      this.contentTypeUserRights_delete = this.settingsService.modulesRolesRights$.value['contentTypes']['D']
    })

  }

  ngDoCheck(): void {
    if (!this.embedded || !this.schemaForm) return;
    const currentState = JSON.stringify({ schema: this.schemaForm.value, metaTemplate: this.metaTemplate });
    if (currentState === this.embeddedState) return;
    this.embeddedState = currentState;
    this.schemaApplied.emit([true, this.schemaForm.value, this.metaTemplate]);
  }

  refreshTree(rebuild = false){
    if (rebuild) {
      this.dataSource.data = [];
      this.changeDetector.detectChanges();
    }
    this.dataSource.data = [...(this.allproperties || [])];
  }

  dropFields(event: CdkDragDrop<SchemaDropList>): void {
    if (event.previousContainer !== event.container) return;

    const movedNode = event.item.data as schemaNode;
    const nodes = event.container.data.nodes;
    const sourceIndex = nodes.indexOf(movedNode);
    if (sourceIndex < 0 || sourceIndex === event.currentIndex) return;

    moveItemInArray(nodes, sourceIndex, event.currentIndex);

    this.allproperties = [...this.allproperties];
    this.selectedFieldPath = this.findNodePath(this.allproperties, movedNode);
    this.schemaForm.patchValue({ properties: this.allproperties, type: 'object' });
    this.refreshTree(true);
  }

  hasChild = (_: number, node: schemaNode) => node.type === 'object' || (node.type === 'array' && node.items?.type === 'object');
  isArrayType = (_: number, node: schemaNode) => node.type === 'array' && node.items?.type !== 'object';

  schemaChildren(node: schemaNode): schemaNode[] {
    if (node.type === 'array') return node.items?.type === 'object' ? node.items.properties || [] : [];
    return node.properties || [];
  }

  private editableChildren(node: schemaNode): schemaNode[] {
    if (node.type === 'array' && node.items && node.items.type === 'object') {
      node.items.properties = node.items.properties || [];
      return node.items.properties;
    }
    node.properties = node.properties || [];
    return node.properties;
  }

  schemaTypeLabel(type: string | undefined): string {
    const translationKeys: Record<string, string> = {
      string: 'text',
      number: 'number',
      boolean: 'boolean',
      array: 'list',
      object: 'key_value',
      date: 'date'
    };
    const key = translationKeys[type || ''];
    return key ? this.translate.instant(`contentTypes.${key}`) : type || '';
  }

  get totalFieldCount(): number {
    return this.countFields(this.allproperties || []);
  }

  get schemaSearchResults(): SchemaSearchResult[] {
    const query = this.schemaSearch.trim().toLocaleLowerCase();
    if (!query) return [];
    const results: SchemaSearchResult[] = [];
    const visit = (nodes: schemaNode[], parentLabel = ''): void => {
      for (const node of nodes) {
        const label = parentLabel ? `${parentLabel}.${node.key}` : node.key;
        if (`${label} ${node.description || ''}`.toLocaleLowerCase().includes(query)) {
          results.push({ node, label, parentLabel });
        }
        visit(this.schemaChildren(node), node.type === 'array' ? `${label}[]` : label);
      }
    };
    visit(this.allproperties || []);
    return results;
  }

  revealSchemaSearchResult(result: SchemaSearchResult): void {
    const path = this.findNodePath(this.allproperties || [], result.node);
    if (!path) return;
    for (let depth = 1; depth < path.length; depth++) {
      const parent = this.getNodeAtPath(this.allproperties, path.slice(0, depth));
      if (parent) this.treeControl.expand(parent);
    }
    this.selectField(result.node);
    this.schemaSearch = '';
    this.changeDetector.detectChanges();
    this.schemaTreeElement?.nativeElement.querySelector('.schema-tree-row.selected')?.scrollIntoView({ block: 'center' });
  }

  get selectedField(): schemaNode | undefined {
    if (!this.selectedFieldPath) return undefined;
    try {
      return this.getNodeAtPath(this.allproperties || [], this.selectedFieldPath);
    } catch {
      return undefined;
    }
  }

  get selectedFieldInheritedAccessFrom(): string | undefined {
    const field = this.selectedField;
    return field ? this.inheritedAccessFrom(field) : undefined;
  }

  get accessRows(): AccessRow[] {
    const rows: AccessRow[] = [];
    const visit = (nodes: schemaNode[], parentPath: number[] = [], parentLabel = ''): void => {
      nodes.forEach((node, index) => {
        const path = [...parentPath, index];
        const label = parentLabel ? `${parentLabel}.${node.key}` : node.key;
        rows.push({ node, path, label, parentLabel, depth: parentPath.length });
        visit(this.schemaChildren(node), path, node.type === 'array' ? `${label}[]` : label);
      });
    };
    visit(this.allproperties || []);
    const query = this.accessSearch.trim().toLocaleLowerCase();
    return rows.filter(row =>
      (!query || row.label.toLocaleLowerCase().includes(query))
      && (this.accessFilter === 'all' || this.accessStatusForPath(row.path, row.node) === this.accessFilter)
    );
  }

  get selectedAccessPathLabel(): string {
    const path = this.selectedFieldPath;
    if (!path) return '';
    const labels: string[] = [];
    for (let depth = 1; depth <= path.length; depth++) {
      const node = this.getNodeAtPath(this.allproperties || [], path.slice(0, depth));
      if (!node) break;
      labels.push(node.key + (node.type === 'array' && depth < path.length ? '[]' : ''));
    }
    return labels.join('.');
  }

  get effectiveSelectedAccess(): Record<string, string[]> | undefined {
    return this.selectedField?.access || this.nearestAccessForPath(this.selectedFieldPath || []);
  }

  get effectiveAccessRoles(): string[] {
    return ['public', ...Object.keys(this.effectiveSelectedAccess || {}).filter(role => role !== 'public')];
  }

  hasEffectiveAccessPermission(role: string, permission: string): boolean {
    return (this.effectiveSelectedAccess?.[role] || []).includes(permission);
  }

  accessStatusForPath(path: number[], node: schemaNode): Exclude<AccessFilter, 'all'> {
    if (node.access) return 'custom';
    return this.accessInheritedFromPath(path) ? 'inherited' : 'open';
  }

  get accessSelectedCount(): number {
    return this.accessSelectedPaths.size;
  }

  get editableVisibleAccessRowCount(): number {
    return this.accessRows.filter(row => this.accessRowEditable(row.path, row.node)).length;
  }

  get accessTargetRoles(): string[] {
    return ['public', ...Object.keys(this.editableAccess || {}).filter(role => role !== 'public')];
  }

  get editableAccess(): Record<string, string[]> | undefined {
    return this.accessBulkMode ? this.bulkAccess : this.selectedField?.access;
  }

  get accessRoleErrorKey(): string | null {
    const role = this.accessNewRole.trim();
    if (!role) return null;
    if (!/^[A-Za-z][A-Za-z0-9_-]*$/.test(role) || ['public', '__proto__', 'constructor', 'prototype'].includes(role)) {
      return 'contentTypes.fieldAccessInvalidRole';
    }
    return Object.prototype.hasOwnProperty.call(this.editableAccess || {}, role)
      ? 'contentTypes.fieldAccessDuplicateRole' : null;
  }

  openAccessView(): void {
    this.saveSelectedField(false);
    this.accessView = true;
    this.accessBulkMode = false;
    this.accessSelectedPaths.clear();
    this.accessNewRole = '';
    if (!this.selectedField && this.allproperties?.length) this.selectField(this.allproperties[0]);
  }

  closeAccessView(): void {
    this.accessView = false;
    this.accessBulkMode = false;
    this.accessSelectedPaths.clear();
    this.accessNewRole = '';
  }

  selectAccessRow(row: AccessRow): void {
    if (this.accessBulkMode) {
      this.toggleAccessRow(row.path, !this.accessRowSelected(row.path));
      return;
    }
    this.selectField(row.node);
    this.accessNewRole = '';
  }

  startAccessBulkEdit(): void {
    this.accessBulkMode = true;
    this.accessFilter = 'all';
    this.bulkAccess = { public: ['R'] };
    this.accessSelectedPaths.clear();
    this.accessNewRole = '';
  }

  stopAccessBulkEdit(): void {
    this.accessBulkMode = false;
    this.accessSelectedPaths.clear();
    this.accessNewRole = '';
  }

  accessRowSelected(path: number[]): boolean {
    return this.accessSelectedPaths.has(JSON.stringify(path));
  }

  accessRowEditable(path: number[], node: schemaNode): boolean {
    return !!node.access || !this.accessInheritedFromPath(path);
  }

  isSelectedAccessPath(path: number[]): boolean {
    return Boolean(this.selectedFieldPath && path.length === this.selectedFieldPath.length
      && path.every((index, depth) => index === this.selectedFieldPath![depth]));
  }

  accessInheritedFromPath(path: number[]): string | undefined {
    for (let depth = path.length - 1; depth > 0; depth--) {
      const parent = this.getNodeAtPath(this.allproperties || [], path.slice(0, depth));
      if (parent?.access) return parent.key;
    }
    return undefined;
  }

  toggleAccessRow(path: number[], checked: boolean): void {
    const key = JSON.stringify(path);
    const node = this.getNodeAtPath(this.allproperties || [], path);
    if (checked && (!node || !this.accessRowEditable(path, node))) return;
    if (checked) this.accessSelectedPaths.add(key);
    else this.accessSelectedPaths.delete(key);
  }

  toggleVisibleAccessRows(checked: boolean): void {
    this.accessRows.forEach(row => this.toggleAccessRow(row.path, checked));
  }

  clearAccessSelection(): void {
    this.accessSelectedPaths.clear();
  }

  get allVisibleAccessRowsSelected(): boolean {
    const rows = this.accessRows.filter(row => this.accessRowEditable(row.path, row.node));
    return rows.length > 0 && rows.every(row => this.accessRowSelected(row.path));
  }

  get someVisibleAccessRowsSelected(): boolean {
    return this.accessRows.some(row => this.accessRowEditable(row.path, row.node) && this.accessRowSelected(row.path))
      && !this.allVisibleAccessRowsSelected;
  }

  setSelectedAccessEnabled(enabled: boolean): void {
    const field = this.selectedField;
    if (!field) return;
    if (enabled && !field.access && this.selectedFieldInheritedAccessFrom) return;
    if (enabled) {
      const inherited = this.nearestAccessForPath(this.selectedFieldPath || []);
      field.access = deepCopy(inherited || { public: ['R'] });
    } else {
      delete field.access;
    }
    this.accessChanged();
  }

  hasSelectedAccessPermission(role: string, permission: string): boolean {
    return (this.editableAccess?.[role] || []).includes(permission);
  }

  setSelectedAccessPermission(role: string, permission: string, checked: boolean): void {
    const access = this.editableAccess;
    if (!access) return;
    if (role === 'public' && permission !== 'R') return;
    const permissions = access[role] || [];
    const updated = {
      ...access,
      [role]: checked ? [...new Set([...permissions, permission])] : permissions.filter(value => value !== permission)
    };
    if (this.accessBulkMode) this.bulkAccess = updated;
    else if (this.selectedField) {
      this.selectedField.access = updated;
      this.accessChanged();
    }
  }

  addSelectedAccessRole(): void {
    const access = this.editableAccess;
    const role = this.accessNewRole.trim();
    if (!access || !role || this.accessRoleErrorKey) return;
    const updated = { ...access, [role]: [] };
    this.accessNewRole = '';
    if (this.accessBulkMode) this.bulkAccess = updated;
    else if (this.selectedField) {
      this.selectedField.access = updated;
      this.accessChanged();
    }
  }

  removeSelectedAccessRole(role: string): void {
    const activeAccess = this.editableAccess;
    if (!activeAccess || role === 'public') return;
    const access = { ...activeAccess };
    delete access[role];
    if (this.accessBulkMode) this.bulkAccess = access;
    else if (this.selectedField) {
      this.selectedField.access = access;
      this.accessChanged();
    }
  }

  async applySelectedAccessToChecked(): Promise<void> {
    if (!this.accessBulkMode || !this.accessSelectedPaths.size) return;
    const confirmed = await firstValueFrom(this.dialog.open(this.accessBulkWarning, {
      width: '440px', maxWidth: '90vw'
    }).afterClosed());
    if (confirmed !== true) return;
    const access = deepCopy(this.bulkAccess);
    const selectedPaths = [...this.accessSelectedPaths].map(encodedPath => JSON.parse(encodedPath) as number[]);
    selectedPaths.sort((left, right) => left.length - right.length);
    let firstUpdated: schemaNode | undefined;
    for (const path of selectedPaths) {
      const field = this.getNodeAtPath(this.allproperties || [], path);
      if (!field || !this.accessRowEditable(path, field)) continue;
      if (!field.access && selectedPaths.some(ancestor => ancestor.length < path.length
        && ancestor.every((index, depth) => index === path[depth]))) continue;
      field.access = deepCopy(access);
      firstUpdated ||= field;
    }
    this.stopAccessBulkEdit();
    this.accessChanged();
    if (firstUpdated) this.selectField(firstUpdated);
  }

  private nearestAccessForPath(path: number[]): Record<string, string[]> | undefined {
    for (let depth = path.length - 1; depth > 0; depth--) {
      const parent = this.getNodeAtPath(this.allproperties || [], path.slice(0, depth));
      if (parent?.access) return parent.access;
    }
    return undefined;
  }

  private accessChanged(): void {
    for (const encodedPath of this.accessSelectedPaths) {
      const path = JSON.parse(encodedPath) as number[];
      const field = this.getNodeAtPath(this.allproperties || [], path);
      if (!field || !this.accessRowEditable(path, field)) this.accessSelectedPaths.delete(encodedPath);
    }
    this.schemaForm.patchValue({ properties: this.allproperties, type: 'object' });
    this.refreshTree();
  }

  private inheritedAccessFrom(field: schemaNode): string | undefined {
    const path = this.findNodePath(this.allproperties || [], field);
    return path ? this.accessInheritedFromPath(path) : undefined;
  }

  get selectedFieldMissingMetaCount(): number {
    const field = this.selectedField;
    return field ? this.missingMetaCountForField(field) : 0;
  }

  private missingMetaCountForField(field: schemaNode): number {
    return getMissingMandatoryMetaFields([{ key: field.key, meta: field.meta }], this.metaTemplate).length;
  }

  get selectedFieldLabel(): string {
    return this.selectedField?.key || this.translate.instant('contentTypes.schemaField');
  }

  nodeIcon(node: schemaNode): string {
    const icons: Record<string, string> = {
      string: 'text_fields',
      number: 'tag',
      boolean: 'toggle_on',
      date: 'calendar_month',
      array: 'format_list_bulleted',
      object: 'account_tree'
    };
    return icons[node.type] || 'data_object';
  }

  private countFields(nodes: schemaNode[]): number {
    return this.schemaEditor.countFields(nodes);
  }

  getAncestors(array, key) {
    if (typeof array != "undefined") {
      for (let i = 0; i < array.length; i++) {
        if (array[i].key === key) {
          return [array[i]];
        }
        const a = this.getAncestors(array[i].properties, key);
        if (a !== null) {
          a.unshift(array[i]);
          return a;
        }
      }
    }
    return null;
  }

  onLeafNodeClick(node: schemaNode) {    
    const ancestors = this.getAncestors(this.dataSource.data, node.key);
    let indexBreadcrumbs=""
    let breadcrumbs = "";
    ancestors.forEach((ancestor,index) => {
      breadcrumbs += `${ancestor.key}/`;
      indexBreadcrumbs += `${index}/`;
    });

    let all={ancestors, breadcrumbs}
    return all
  }


  initializeForm(){
    const {schema} =  this.contenttype
    const {properties, type}=this.schemaData

    this.contentForm.patchValue({
      schema: schema ? schema : undefined
    })

    this.schemaForm.patchValue({
      properties: properties ? properties : [],
      type: type ? type : undefined
    })
    this.schemaEditor.restrictPublicAccess(this.allproperties || []);
    
    this.dataSource.data = this.allproperties

  }

  initializeDefaultForm(){

    this.allproperties = []

    this.contentForm.patchValue({
      schema: undefined
    })

    this.schemaForm.patchValue({
      properties: [],
      type: "object"
    })
    
    this.dataSource.data = this.allproperties

  }

  backTo(){
  }

  addProperty(){
    let dialogRef= this.dialog.open(ContentTypesSchemaPropertiesDialogComponent, {
      data: { 
        type:"add",
        data: {},
        values:this.schemaData,
        metaTemplate: this.metaTemplate
      },
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        const newProperty = { ...result[1], ...(result[2] ? { meta: result[2] } : {}), ...(result[3] ? { access: result[3] } : {}) };
        let properties = this.allproperties
        if(properties){
          if(properties.length==0){
            properties.push(newProperty)
            this.schemaForm.patchValue({type: 'object'})
          }else{
            properties.push(newProperty)
          }
        }else{
          properties=[]
          properties.push(newProperty)
          this.schemaForm.patchValue({type: 'object'})
        }

        this.schemaForm.patchValue({properties: properties})
        this.allproperties=properties
        this.dataSource.data = this.allproperties

        this.refreshTree()
        this.selectField(newProperty)
      }
    });
  }

  async importSchema(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    if (this.allproperties?.length) {
      const confirmed = await firstValueFrom(this.dialog.open(this.schemaImportWarning, {
        width: '440px',
        maxWidth: '90vw'
      }).afterClosed());
      if (confirmed !== true) {
        input.value = '';
        return;
      }
    }
    try {
      this.commentService.progressSpin.emit(true);
      const schemaImport: { properties: schemaNode[]; metaTemplate?: SchemaMetaTemplate; warnings?: string[] } = file.name.toLowerCase().endsWith('.json')
        ? await this.readJsonSchema(file)
        : { properties: await this.excelImportService.readSchema(file) };
      const properties = schemaImport.properties;
      this.schemaEditor.restrictPublicAccess(properties);
      this.allproperties = properties;
      this.accessSelectedPaths.clear();
      if (schemaImport.metaTemplate) this.metaTemplate = deepCopy(schemaImport.metaTemplate);
      this.schemaForm.patchValue({ type: 'object', properties });
      this.dataSource.data = properties;
      this.refreshTree();
      properties.forEach(node => {
        if (this.hasChild(0, node)) this.treeControl.expand(node);
      });
      this.clearSelectedField();
      this.schemaImportFieldCount = this.schemaEditor.countFields(properties);
      this.commentService.addSnackBar.emit(this.translate.instant('contentTypes.schemaImportSuccess', { count: this.schemaImportFieldCount }));
      if (schemaImport.warnings?.length) {
        this.schemaImportWarnings = schemaImport.warnings.map(warning => {
          const separator = warning.indexOf(': ');
          return separator < 0
            ? { path: '', message: warning }
            : { path: warning.slice(0, separator), message: warning.slice(separator + 2) };
        });
        this.dialog.open(this.schemaImportWarningsDialog, { width: '720px', maxWidth: '90vw', maxHeight: '80vh' });
      }
    } catch (error: any) {
      const message = error instanceof SchemaImportError
        ? this.translate.instant(error.translationKey, error.translationParams)
        : error?.message || this.translate.instant('contentTypes.schemaImportFailed');
      this.commentService.addSnackBar.emit(message);
    } finally {
      this.commentService.progressSpin.emit(false);
      input.value = '';
    }
  }

  exportSchema(format: 'json' | 'xlsx' | 'csv' = 'json'): void {
    const schema = { type: 'object', properties: this.allproperties || [] };
    const fileName = `${this.schemaExportFileName()}-datenstruktur`;
    if (format === 'json') {
      const payload = { schema, metaTemplate: this.metaTemplate };
      const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
      saveAs(blob, `${fileName}.json`);
      return;
    }

    const headers = ['key', 'type', 'description', 'mandatory', 'listItemsType', 'dateFormat', 'validators', 'meta', 'access'];
    const rows = this.schemaExportRows();
    if (format === 'xlsx') {
      const sheet = XLSX.utils.aoa_to_sheet([headers, ...rows.map(row => headers.map(header => row[header] || ''))]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, this.translate.instant('contentTypes.schema'));
      const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${fileName}.xlsx`);
      return;
    }

    const csv = [headers, ...rows.map(row => headers.map(header => row[header] || ''))]
      .map(row => row.map(value => this.csvCell(value)).join(','))
      .join('\n');
    saveAs(new Blob(['\ufeff', csv], { type: 'text/csv;charset=utf-8' }), `${fileName}.csv`);
  }

  downloadSampleJson(): void {
    const samplePayload = this.createEmptyPayload(this.allproperties || []);
    const blob = new Blob([JSON.stringify(samplePayload, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `${this.displayName || 'dpp-typ'}-beispiel.json`;
    anchor.click();
    URL.revokeObjectURL(url);
  }

  private createEmptyPayload(nodes: schemaNode[]): Record<string, unknown> {
    return this.schemaEditor.createEmptyPayload(nodes);
  }

  private schemaExportRows(): Array<Record<string, string>> {
    const rows: Array<Record<string, string>> = [];
    const addRows = (nodes: schemaNode[], prefix = ''): void => {
      nodes.forEach(node => {
        const path = prefix ? `${prefix}.${node.key}` : node.key;
        rows.push({
          key: path,
          type: node.type,
          description: node.description || '',
          mandatory: node.mandatory === true ? 'true' : 'false',
          listItemsType: node.type === 'array' ? node.items?.type || 'string' : '',
          dateFormat: node.dateFormat || '',
          validators: node.validators?.length ? JSON.stringify(node.validators) : '',
          meta: node.meta && Object.keys(node.meta).length ? JSON.stringify(node.meta) : '',
          access: node.access ? JSON.stringify(node.access) : ''
        });
        if (node.type === 'object') addRows(node.properties || [], path);
        if (node.type === 'array' && node.items?.type === 'object') addRows(node.items.properties || [], `${path}[]`);
      });
    };
    addRows(this.allproperties || []);
    return rows;
  }

  private schemaExportFileName(): string {
    return String(this.displayName || 'dpp-typ').trim().replace(/[^a-zA-Z0-9_-]+/g, '-') || 'dpp-typ';
  }

  private csvCell(value: string): string {
    return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
  }

  private async readJsonSchema(file: File): Promise<{ properties: schemaNode[]; metaTemplate?: SchemaMetaTemplate; warnings?: string[] }> {
    const json = JSON.parse(await file.text());
    if (json?.['$schema'] || json?.['$ref'] || (json?.type === 'object' && json?.properties && !Array.isArray(json.properties))) {
      return this.jsonSchemaImport.import(json);
    }
    const schema = json?.schema || json;
    const properties = Array.isArray(schema) ? schema : schema?.properties;
    if (!Array.isArray(properties) || !properties.length) throw new Error(this.translate.instant('contentTypes.schemaImportNoFields'));
    if (!properties.every(node => node?.key && node?.type)) throw new Error(this.translate.instant('contentTypes.schemaImportInvalidField'));
    return { properties, metaTemplate: json?.metaTemplate };
  }

  selectField(node: schemaNode): void {
    const path = this.findNodePath(this.allproperties || [], node);
    if (!path) return;
    this.selectedFieldPath = path;
    this.metaExpanded = this.metaTemplate.fields.length > 0;
    this.selectedFieldForm.patchValue({
      type: node.type || undefined,
      key: node.key || undefined,
      description: node.description || undefined,
      mandatory: node.mandatory === true,
      listItemsType: node.items?.type || undefined
    }, { emitEvent: false });
  }

  isSelectedField(node: schemaNode): boolean {
    const path = this.findNodePath(this.allproperties || [], node);
    return Boolean(path && this.selectedFieldPath && JSON.stringify(path) === JSON.stringify(this.selectedFieldPath));
  }

  clearSelectedField(): void {
    this.selectedFieldPath = undefined;
    this.metaExpanded = false;
    this.selectedFieldForm.reset({ mandatory: false });
  }

  saveSelectedField(showValidationMessage = true): void {
    if (!this.selectedFieldPath || this.selectedFieldForm.invalid) {
      if (showValidationMessage) {
        this.commentService.addSnackBar.emit(this.translate.instant("SnackBarConstants.MANDATORY_FIELDS_EMPTY"));
      }
      return;
    }

    // NestedTreeControl tracks expansion by node reference.
    const node = this.getNodeAtPath(this.allproperties || [], this.selectedFieldPath);
    if (!node) return;
    const { type, key, description, mandatory, listItemsType } = this.selectedFieldForm.value;
    const previousType = node.type;
    const previousItemType = node.items?.type;

    node.type = type;
    node.key = key;
    node.description = description || undefined;
    node.mandatory = mandatory === true;

    if (type === 'array') {
      const itemType = listItemsType || node.items?.type || 'string';
      node.items = {
        ...(node.items || {}),
        key: node.items?.key || 'items',
        type: itemType
      };
      if (itemType === 'object') node.items.properties = node.items.properties || [];
      else delete node.items.properties;
      delete node.properties;
    } else if (type === 'object') {
      node.properties = node.properties || [];
      delete node.items;
    } else {
      delete node.items;
      delete node.properties;
    }

    this.schemaForm.patchValue({ properties: this.allproperties, type: 'object' });
    this.refreshTree(previousType !== type || (type === 'array' && previousItemType !== node.items?.type));
  }

  updateMetaTemplate(metaTemplate: SchemaMetaTemplate): void {
    this.metaTemplate = deepCopy(metaTemplate);
    this.metaExpanded = this.metaTemplate.fields.length > 0;
  }

  updateSelectedFieldMeta(meta: SchemaFieldMeta | undefined): void {
    if (!this.selectedFieldPath) return;
    const field = this.getNodeAtPath(this.allproperties || [], this.selectedFieldPath);
    if (!field) return;
    if (meta && Object.keys(meta).length) field.meta = deepCopy(meta);
    else delete field.meta;
    this.schemaForm.patchValue({ properties: this.allproperties, type: 'object' });
    this.refreshTree();
  }

  openMetaTemplateEditor(): void {
    const ref = this.dialog.open(SchemaMetaTemplateDialogComponent, {
      width: '760px',
      maxWidth: '94vw',
      data: { metaTemplate: this.metaTemplate }
    });
    ref.afterClosed().subscribe(result => {
      if (!result?.[0]) return;
      this.updateMetaTemplate(result[1] || EMPTY_SCHEMA_META_TEMPLATE);
    });
  }

  openSelectedFieldDetails(): void {
    const node = this.selectedField;
    if (!node) return;
    this.editProperty(node, 0);
  }


  editProperty(data, index){
    let dialogRef= this.dialog.open(ContentTypesSchemaPropertiesDialogComponent, {
      data: { 
        schemaType : data.type ?? undefined,
        type:"edit",
        data,
        values:this.schemaData,
        metaTemplate: this.metaTemplate,
        inheritedAccessFrom: this.inheritedAccessFrom(data)
      },
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        const previousType = data.type;
        const previousItemType = data.items?.type;
        const value = this.removeOnlyUndefined(result[1])
        const keys = Object.keys(value)

        keys.forEach(key => data[key] = value[key])
        if (data.type === 'array') {
          delete data.properties;
          if (data.items?.type === 'object') data.items.properties = data.items.properties || [];
          else if (data.items) delete data.items.properties;
        } else if (data.type === 'object') {
          delete data.items;
          data.properties = data.properties || [];
        } else {
          delete data.items;
          delete data.properties;
        }
        if (result[2]) data.meta = result[2];
        else delete data.meta;
        if (result[3]) data.access = result[3];
        else delete data.access;
        this.schemaForm.patchValue({properties: this.allproperties})
        this.refreshTree(previousType !== data.type || previousItemType !== data.items?.type)
      }
    });
  }

  async getContentTypeId(){
    try{
      this.commentService.progressSpin.emit(true)
      this.contenttype = await this.settingsService.observeContextsContentTypesIdFirestore(this.idToShow)
      this.contentData= new ContentType 
      this.contentData.setFromAny(this.contenttype)

      if(this.contenttype.displayName)
        this.displayName = this.contenttype.displayName

      if(!this.contentData['id']){
        this.contentData['id']= this.idToShow
      }
  
      this.commentService.progressSpin.emit(false)

    }catch(error){
      console.log(error)
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.LOAD_FAILED")
      this.commentService.addSnackBar.emit(message)

    }
  }

  clickPropertyList(data, index){
  }

  addNewProperty(node,index){
    let dialogRef= this.dialog.open(ContentTypesSchemaPropertiesDialogComponent, {
      data: { 
        type:"add_toObject",
        values:node,
        metaTemplate: this.metaTemplate,
        inheritedAccessFrom: node.access ? node.key : this.inheritedAccessFrom(node)
      },
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        const parentPath = this.findNodePath(this.allproperties, node);
        if (!parentPath) return;

        const expandedPaths = this.expandedObjectPaths();
        const newProperty = { ...result[1], ...(result[2] ? { meta: result[2] } : {}), ...(result[3] ? { access: result[3] } : {}) };
        const updatedProperties = deepCopy(this.allproperties);
        const updatedParent = this.getNodeAtPath(updatedProperties, parentPath);
        if (!updatedParent) return;
        this.editableChildren(updatedParent).push(newProperty);

        this.allproperties = updatedProperties;
        this.schemaForm.patchValue({properties: this.allproperties})
        this.treeControl.expansionModel.clear();
        this.dataSource.data = [];
        this.changeDetector.detectChanges();
        this.dataSource.data = [...this.allproperties];
        for (const path of [...expandedPaths, parentPath]) {
          const expandedNode = this.getNodeAtPath(this.allproperties, path);
          if (expandedNode && this.hasChild(0, expandedNode)) this.treeControl.expand(expandedNode);
        }
        this.selectField(newProperty);
        this.changeDetector.detectChanges();

      }

    });
  }

  private expandedObjectPaths(): number[][] {
    const paths: number[][] = [];
    const visit = (nodes: schemaNode[], parentPath: number[] = []): void => {
      nodes.forEach((candidate, index) => {
        const path = [...parentPath, index];
        if (this.hasChild(0, candidate) && this.treeControl.isExpanded(candidate)) paths.push(path);
        visit(this.schemaChildren(candidate), path);
      });
    };
    visit(this.allproperties || []);
    return paths;
  }

  private findNodePath(nodes: schemaNode[], targetNode: schemaNode, parentPath: number[] = []): number[] | undefined {
    return this.schemaEditor.findNodePath(nodes, targetNode, parentPath);
  }

  private getNodeAtPath(nodes: schemaNode[], path: number[]): schemaNode | undefined {
    return this.schemaEditor.getNodeAtPath(nodes, path);
  }

  private removeOnlyUndefined(values: Record<string, any>): Record<string, any> {
    return Object.fromEntries(Object.entries(values || {}).filter(([, value]) => value !== undefined));
  }


  onCancel(){
    this.dialogRef?.close([false])
  }

  onSave(){
    const missingMetaFields = getMissingMandatoryMetaFields(this.allproperties || [], this.metaTemplate);
    if (missingMetaFields.length) {
      this.commentService.addSnackBar.emit(this.translate.instant('contentTypes.mandatoryMetaMissing', {
        fields: `${missingMetaFields.slice(0, 3).join(', ')}${missingMetaFields.length > 3 ? ' ...' : ''}`
      }));
      return;
    }
    this.dialogRef?.close([true, this.schemaForm.value, this.metaTemplate]);
  }

  clickList(){
  }
  
  deleteNode(node: schemaNode, index: number) {
    // Recursive function to delete a node and its children
    const deleteNodeRecursive = (nodes: schemaNode[], targetNode: schemaNode) => {
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i] === targetNode) {
          // Remove the node from the array
          nodes.splice(i, 1);
          this.clearSelectedField();
          return true; // Node found and deleted
        }
        if (nodes[i].properties) {
          // Recursively search in nested properties
          if (deleteNodeRecursive(nodes[i].properties, targetNode)) {
            return true; // Node found and deleted in nested properties
          }
        }
        if (nodes[i].items) {
          // Recursively search in array items
          if (deleteNodeRecursive([nodes[i].items], targetNode)) {
            return true; // Node found and deleted in array items
          }
        }
      }
      return false; // Node not found
    };
  
    // Start the recursive deletion from the root
    deleteNodeRecursive(this.allproperties, node);
  
    // Refresh the tree
    this.schemaForm.patchValue({properties: this.allproperties});
    this.dataSource.data = this.allproperties;
    this.refreshTree(true);
  }
}
